import { Module } from 'vuex-smart-module';
import PartnerCompanyActions from './actions';
import PartnerCompanyGetters from './getters';
import PartnerCompanyMutations from './mutations';
import PartnerCompanyState from './state';

export default new Module({
  state: PartnerCompanyState,
  mutations: PartnerCompanyMutations,
  actions: PartnerCompanyActions,
  getters: PartnerCompanyGetters,
});
